<script setup lang="ts">
defineProps({
  query: {
    type: String,
    required: false,
  },
})
</script>

<template>
  <section
    class="mb-48 mt-14 w-full grow px-5 font-semibold lg:mx-auto lg:max-w-screen-lg"
    data-testid="no-results-msg"
  >
    <p v-if="query">
      Sorry, we couldn’t find any results for
      <span class="mt-1 block break-all text-2xl font-bold">
        “{{ query }}”
      </span>
    </p>
    <p v-else> Sorry, we couldn’t find any results.</p>
  </section>
</template>
